import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, of } from 'rxjs';
import { DatePipe, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiUrl = environment.apiUrl;
  nodeUrl = environment.nodeApi;
  public isLoggedIn = new Subject();
  private readonly isBrowser;
  private EventSubject = new Subject<any>();
  private cmsPageObj = new Subject<any>();
  private enabelLoader = new Subject<any>();
  constructor(
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private router: Router,
    private titleService:Title,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  get(endPoint: string, data: any = {}) {
    return this.httpClient.get(this.apiUrl + endPoint, { params: data }).pipe(
      catchError(this.handleError<{}>('Get'))
    );
  }
  post(endPoint: string, data: any = {}) {
    return this.httpClient.post(this.apiUrl + endPoint, data).pipe(
      catchError(this.handleError<{}>('Add'))
    );
  }
  patch(endPoint: string, data: any = {}) {
    return this.httpClient.patch(this.apiUrl + endPoint, data).pipe(
      catchError(this.handleError<{}>('Update'))
    );
  }
  put(endPoint: string, data: any = {}) {
    return this.httpClient.put(this.apiUrl + endPoint, data).pipe(
      catchError(this.handleError<{}>('Update'))
    );
  }
  delete(endPoint: string, data: any = {}) {
    return this.httpClient.delete(this.apiUrl + endPoint, { params: data }).pipe(
      catchError(this.handleError<{}>('Delete'))
    );
  }
  nodeApi(endPoint: string, data: any = {}) {
    return this.httpClient.post(this.nodeUrl + endPoint, data).pipe(
      catchError(this.handleError<{}>('update'))
    );
  }
  verifyToken() {
    return this.get('verify/token');
  }

  getStoreDetails() {
    if (!this.loggedIn()) {
      return this.httpClient.get('/api/v1/store');
    } else {
      return this.get('store', {});
    }
  }

  getPlacesAutocomplete(params: string) {
    return this.get('places-autocomplete?input=' + params);
  }

  getReverseGeocode(params: string) {
    return this.get('reverse-geocode?place_id=' + params);
  }

  getStateList() {
    return this.get('state');
  }

  getCountyList(params) {
    return this.get('county/' + params);
  }

  categories() {
    if (!this.loggedIn()) {
      return this.httpClient.get('/api/v1/category');
    } else {
      return this.get('category');
    }
  }

  getProductsBasedOnCategory(data) {
    if (!this.loggedIn()) {
      return this.httpClient.get('/api/v1/product/search/1', { params: data });
    } else {
      if (sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
        data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
      }
      return this.get('product/search', data);
    }
  }
  searchProductsInSolr(data: Object) {
    return this.get('solr/search-products', data);
  }
  getSearchProductsInSolr(data: Object) {
    return this.get('solr/search-products/1', data);
  }
  customerRegister(params: Object) {
    return this.post('user', params);
  }

  checkCustomerIsAlreadyExist(params: Object) {
    return this.post('user/check/exist', params);
  }

  checkCustomerPassword(params: Object) {
    return this.post('user/checkpassword', params);
  }

  checkZipcode(params: Object) {
    return this.post('zipcode', params);
  }

  updateCustomerDetails(params: Object) {
    return this.patch('user', params);
  }

  forgotPassword(params: string) {
    return this.post('user/forget', { email_id: params });
  }

  getDeliveryCalandar(params: Object) {
    return this.post('user/dates', params);
  }

  searchProducts(data) {
    if (!this.loggedIn()) {
      data['public_page'] = 1;
      return this.httpClient.get('/api/v1/product/keysearch/1', { params: data });
    } else {
      // data['edit_cart'] = 3;
      if (sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
        data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
      }
      return this.get('product/keysearch', data);
    }
  }

  customerLogin(params: any) {
    return this.post('user/login', params)
  }
  saveRegister(params: any) {
    return this.post('user/saveRegister', params)
  }
  deliveryCheck(params: any) {
    return this.nodeApi('route-assigner/find-routes', params)
  }
  saveContactRoutes(params:any){
    return this.post('saveContactRoutes', params)
  }
  savePickupLocation(params:any){
    return this.put('savePickupLocation', params)
  }
  getAutheticatedUserDetails() {
    if(this.isBrowser){
    let selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    let delivery_date = "";
    if (!!selectedDeliveryCalendar && !!selectedDeliveryCalendar['delivery_date']) {
      delivery_date = this.datePipe.transform(selectedDeliveryCalendar['delivery_date'], 'MM/dd/yyyy');
      delivery_date = `?delivery_date=${delivery_date}`;
    }
    return this.get('user' + delivery_date)
  }
  }

  loggedIn() {
    return !!localStorage.getItem('token');
  }

  setLogin(val: any): void {
    const user = val.userDetails;
    const userId = user?.id || null;
    if(userId){
      sessionStorage.setItem('userId', userId);
    }
    this.isLoggedIn.next(val);
  }

  getLogin(): Observable<any> {
    return this.isLoggedIn.asObservable();
  }
  getCart(data) {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.get('user/cart', data);
  }
  addCart(data) {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.post('user/cart', data);
  }
  getOrder() {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      var data = {
        ['delivery_date']: this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy')
      };
    }
    return this.get('user/order', data);
  }
  getRecurring() {
    var data = {}
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.get('user/recurring', data);
  }
  logout() {
    sessionStorage.removeItem('userId');
    return this.get('user/logout');
  }
  updateCart(data) {
    return this.patch('user/cart?cart_product_id=' + data['cart_product_id'], data);
  }
  deleteCart(data) {
    return this.delete('user/cart?cart_product_id=' + data['cart_product_id'], {})
  }
  deleteAllCart() {
    return this.delete('user/cart')
  }
  deleteRecurring(data) {
    return this.put('user/recurring/' + data['id'], data);
  }
  skipCartRecurring(data) {
    return this.put('user/recurring/' + data['id'], data);
  }
  unskipCartRecurring(data) {
    return this.put('user/recurring/' + data['recurring_id'], data);
  }
  updateRecurring(data) {
    return this.patch('user/recurring?recurring_id=' + data['recurring_id'], data);
  }
  addThisWeek(data) {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.post('user/recurring/addcart', data);
  }
  saveOrder(data) {  
    // if(data['items'][0]['pre_order']===true)
    // {
    //   data['delivery_date'] = this.datePipe.transform(data['items'][0]['pre_order_delivery_date'], 'MM/dd/yyyy');
    // } else{
      // if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      //   data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
      // }
    // }
    
    return this.post('user/order', data);
  }
  getVendor() {
    if (!this.loggedIn()) {
      return this.httpClient.get('/api/v1/vendor');
    } else {
      return this.get('vendor');
    }
  }

  getCreditCardList() {
    return this.get('user/card');
  }

  addNewCreditCard(params: object) {
    return this.post('user/card', params);
  }

  updateCreditCard(params: object) {
    return this.patch('user/card', params);
  }

  setDefaultCreditCard(param: number) {
    return this.put('user/card/' + param);
  }

  deleteCreditCard(param: number) {
    return this.delete('user/card/' + param);
  }

  getPickupLocation() {
    return this.get('findPickupLocations');
  }

  findDeliveryRoute(params: object) {
    return this.post('findRoutes', params);
  }

  getSaleOrders(pre_order = false) {
    var data = {};
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    if(pre_order===true)
    {
      data['pre_order'] = true;
    }
    return this.get('user/order', data);
  }

  getSingleSaleOrder(param,fromSaleDetails =false){
    var data = {};
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      if(!fromSaleDetails){
        data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
      }  
     
    }
    return this.get('user/order/' + param, data);
  }

  updateSaleOrderStatus(params: object) {
    return this.put('user/order/action', params);
  }

  editSaleOrder(param) {
    return this.post('user/order/edit/' + param);
  }
  updateSaleOrder(data) {
    return this.patch('user/order?sale_product_id=' + data['sale_product_id'], data);
  }
  deleteSaleProduct(data) {
    return this.delete('user/order?sale_product_id=' + data['sale_product_id']);
  }
  addProductsToSaleOrder(data) {
    // if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
    //   data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    // }
    return this.post('user/order/addproducts', data);
  }
  getMenus() {
    if (!this.loggedIn()) {
      return this.httpClient.get('/api/v1/menus');
    } else {
      return this.get('menus');
    }
  }
  checkOrderForRecurringDelete(data) {
    return this.get(`user/order/checkSaleOrder?recurring_id=${data['id']}&website_check=global`)
  }

  downloadInvoice(data) {
    // return this.get('user/order/invoice/'+data);
    return this.httpClient.get(this.apiUrl + 'user/order/invoice/' + data, {
      responseType: 'blob',
      headers: { Accept: 'application/pdf' }
    })
  }

  saveSpecialInstruction(params) {
    return this.post('user/order/saveInstruction', params);
  }

  cancelScheduledOrder(data) {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.post('user/order/cancel', data);
  }
  singleRecurring(data) {
    return this.get(`user/recurring/getSingleRecurring?recurring_id=${data['recurringId']}&limit=${data['limit']}`);
  }
  addVacationDates(data) {
    return this.post('user/recurring/vacation', data);
  }
  editVacationDates(data) {
    return this.patch(`user/recurring/vacation?vacation_id=${data['vacationId']}`, data);
  }
  cancelVacationDates(data) {
    return this.delete(`user/recurring/vacation?vacation_id=${data['vacationId']}`);
  }
  saveOtpToken(data) {
    return this.get(`token?phone=${data['phone']}&token=${data['verificationId']}`)
  }
  loginWithPhone(data) {
    return this.post('user/loginOtp', data);
  }
  saveOrderComments(data) {
    if (this.loggedIn() && sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
      data['delivery_date'] = this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
    }
    return this.post('user/cart/msg', data);
  }

  getFeatureTags(params) {
    return this.httpClient.get(`${this.apiUrl}featureTags`,{ params }  );
  }
  
  getContentItems(params: object) {
    return this.get('content_items', params);
  }
  // getCmsContentItems(params: object) {
  //   return this.get('user/cms', params);
  // }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error);
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      if (error && error['status'] === 404) {
        this.router.navigateByUrl('**', { skipLocationChange: true });
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  sendEvent(isTrue: any) {
    this.EventSubject.next(isTrue);
  }

  getEvent() {
    return this.EventSubject.asObservable();
  }
  GetCmsPage() {
    return this.cmsPageObj.asObservable();
  }
  SetCmsPage(Page: any) {
    this.cmsPageObj.next(Page);
  }
  getLoader() {
   return this.enabelLoader.asObservable();;
  }
  setLoader(isTrue: any) {
    this.enabelLoader.next(isTrue);
  }
  // setTile(from){
  //   this.titleService.setTitle(from + ':: Hudson Milk + Market - Farmers Market on Wheels to Westchester, Putnam and Fairfield Counties');
  // }
  // GetCMSPageAPI(name) {
  //   let storeId = JSON.parse(sessionStorage.getItem('store')).id;
  //   this.getCmsContentItems({type: 'cms', store_id:storeId, handle:name});
  // }
  // cmsPageObj

  getProductPairStats(params){
    return this.get('product_pairs_stats/'+params);
  }
  applyCouponCode(data){ 
    return this.post('couponCode',data);
  }
  removeCoupon(data){
    return this.delete(`couponCode?product_id=${data['product_id']}&cart_id=${data['cart_id']}&sale_order_id=${data['sale_order_id']}`);
  }

  updateOrder(params){
    return this.patch(`user/order?sale_product_id=${params.sale_product_id}`,params);
  }

  resetPasswordToken(params){
    return this.get('user/resetpassword/'+params);
  }
  resetPasswordCustomerToken(params){
    return this.get('user/resetpasswordcustomertoken/'+params);
  }
  updateResetPassword(data){
    return this.post('user/passwordChange', data);
  }
  updateResetPasswordCustomer(data){
    return this.post('user/resetPasswordForm', data);
  }
  getTipsSettings(){
    return this.get('getTipsSettings');
  }

  updateOrderTip(id, params){
    return this.put(`updateOrderTip/${id}`, params);
  }

  updateTipinCustomerProfile(params){
    return this.patch('updateCustomerRecurringTip', params);
  }

  saveAptSuiteNo(params){
    return this.patch('saveAptSuiteNo', params);
  }
  
  getWaitListMessage(){
    return this.get('getWaitListMessage');
  }
  getDeliveryDatesForRecurringItem(id){
    return this.get(`user/recurring/nextRecurringDates/${id}`);
  }
  getPaymentHistory(){
    return this.get('user/customerProfilePayment');
  }
  getDeliveryDates(params: Object) {
    return this.get('user/getUpcomingEvents', params);
  }
  saleOrders(payload: any = {}){
    const queryParams = new URLSearchParams(payload).toString();
    return this.get(`user/order/saleOrdersDetails?${queryParams}`);
  }
  changeDeliveryDate(param: Object) {
    return this.put('user/order/moveOrder', param);
  }
  // orderSummary(){
  //   return this.get(`user/order/getSalesOrderDetails`);
  // }
  unskipOrder(data) {
    return this.put('user/order/unskip', data);
  }
  checkOrderForVacationDelete(data) {
    return this.get(`user/order/checkSaleOrder?vacation_start_date=${data['start_date']}&vacation_end_date=${data['end_date']}&website_check=global`)
  }
  getMembershipTax(productId: number) {
    return this.get('user/memberships/membership_product', { membership_product_id: productId });
  }
  membershipDetails() {
    return this.get('user/memberships/membershipDetails');
  }
  purchaseMembership(data) {
    return this.post('user/memberships/purchase', data);
  }
  cancelMembership(data) {
    return this.put('user/memberships/cancel', data);
  }
  pickupEvent(id) {
    return this.get(`pickup_events/${id}`);
  }
  setPaymentPreferrance(data) {
    return this.post('user/setPaymentPreferrance', data);
  }
}
